import { Routes, Route, Navigate } from 'react-router-dom';


import TenantWrapper from './TenantWrapper';
import RequireAuth from './components/RequireAuth';

import Marketplace from './pages/Marketplace';
import FoundationInfo from './pages/FoundationInfo';
import CampaignInfo from './pages/CampaignInfo/CampaignInfo';
import Results from './pages/Results/Results';
import Login from './pages/Login/Index';
import AdminLayout from './pages/admin/AdminLayout';
import Dashboard from './pages/admin/dashboard/Index';
import AdmFound from './pages/admin/foundations/Index';
import AdmTrans from './pages/admin/transactions/Index';
import AdmCamp from './pages/admin/campaigns/Index';

function AppRoutes() {
  return (
    <Routes>
      <Route path=':company' element={<TenantWrapper />}>
        <Route
          index
          element={<Marketplace />}
        />
        <Route
          path='foundation/:id'
          element={<FoundationInfo />}
        />
        <Route
          path='campaign/:id'
          element={<CampaignInfo />}
        />
        <Route
          path='results/:id'
          element={<Results />}
        />
        <Route
          path='login'
          element={<Login />}
        />
        <Route
          path='admin'
          element={
            <RequireAuth>
              <AdminLayout />
            </RequireAuth>
          }>
          <Route
            index
            element={<Navigate to='dashboard' />}
          />
          <Route
            path='dashboard'
            element={<Dashboard />}
          />
          <Route
            path='foundations'
            element={<AdmFound />}
          />
          <Route
            path='campaigns'
            element={<AdmCamp />}
          />
          <Route
            path='disbursements'
            element={<Dashboard />}
          />
          <Route
            path='transactions'
            element={<AdmTrans />}
          />
        </Route>
      </Route>
    </Routes>
  );
}

export default AppRoutes;
